import { Season, SeasonIdTemp } from "../../models/Season";
import { Router } from "../../utils/Router";
import { Selector } from "../../utils/Selector";

export class SeasonSelector extends Selector<Season, Season["season_id"]>{
    checkDefault = (item: Season) => {
        const isTemp = item.season_id === SeasonIdTemp.LAST_LIVE || item.season_id === SeasonIdTemp.LIVE,
        check = Router.isUrl(Router.SEASON_BASE_URL + item.season_id) || (isTemp && Router.isUrl(Router.getBaseUrl()))

        return check
    }

    getLabel = (item: Season) => item?.season_name

    getKey = (item: Season) => item.season_id
}